import React from "react";
const H1 = ({ children, className }) => /* @__PURE__ */ React.createElement("h1", { className: `font-heading my-3 text-3.5xl font-semibold ${className}` }, children);
const H2 = ({ children, className }) => /* @__PURE__ */ React.createElement("h2", { className: `font-heading my-3 text-3xl font-semibold ${className}` }, children);
const H3 = ({ children, className }) => /* @__PURE__ */ React.createElement("h3", { className: `font-heading my-3 text-2xl font-semibold ${className}` }, children);
export { H1, H2, H3 };
